export default __webpack_public_path__ + "static/media/ico_email_white.0d9d0084.svg";